import { render, staticRenderFns } from "./ToolQa.vue?vue&type=template&id=f73f89b8"
import script from "./ToolQa.vue?vue&type=script&lang=js"
export * from "./ToolQa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports